import React from 'react';
import cx from 'clsx';
import AssetLayer from '../AssetLayer';
import { LayersWrapper } from '../game-tile';
import styles from './JackpotLogo.module.scss';
import { WrapperImages } from './types';

interface JackpotLogoProps {
  logo: WrapperImages['logo'] | undefined;
}

export const JackpotLogo = ({ logo }: JackpotLogoProps) => {
  const imageSource = logo && {
    normal: logo.source.modern?.normal || logo.source.normal,
    retina: logo.source.modern?.retina || logo.source?.retina,
  };

  return (
    <div className={cx(styles.image)} data-testid="jackpots-wrapper-image">
      <LayersWrapper>
        <AssetLayer
          imageSrc={imageSource}
          imageAttributes={{ style: { maxWidth: '100%' } }}
          alt={logo?.alt || ''}
          isLazy={true}
          type="image"
          fallbackBackgroundColor="transparent"
        />
      </LayersWrapper>
    </div>
  );
};
